var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaiga(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2500,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.288 43.916l-11.963 84.2-84.2-11.963 11.963-84.2 84.2 11.963z",
    opacity: 0.8,
    fill: "#A295AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.885 212.291l11.963-84.2 84.2 11.963-11.963 84.2-84.2-11.963z",
    opacity: 0.8,
    fill: "#5D6F6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.848 32.065l84.2 11.962-11.963 84.2-84.2-11.963 11.963-84.2z",
    opacity: 0.8,
    fill: "#8CD592"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.226 224.264l-84.2-11.963 11.963-84.2 84.2 11.963-11.963 84.2z",
    opacity: 0.8,
    fill: "#665E74"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.642 255.595l-51.08-67.997 67.998-51.08 51.08 67.998-67.998 51.08z",
    opacity: 0.8,
    fill: "#3C3647"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M255.463 136.39l-67.997 51.079-51.08-67.997 67.998-51.08 51.08 67.998z",
    opacity: 0.8,
    fill: "#837193"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.437.554l51.079 67.997-67.997 51.08-51.08-67.998L136.437.553z",
    opacity: 0.8,
    fill: "#A2F4AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M.463 119.7l67.998-51.08 51.079 67.998-67.997 51.08L.463 119.7z",
    opacity: 0.8,
    fill: "#7EA685"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.963 95.742l32.332 32.333-32.332 32.332-32.332-32.332 32.332-32.333z",
    fill: "#3C3647"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaiga);
export default __webpack_public_path__ + "static/media/taiga.6929fabc9fb81fb8ade916b02b1ca76c.svg";
export { ForwardRef as ReactComponent };